import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';
import networkService from '../Network/NetworkManager';
const APPURL = require('../Constants/URLConstants');

export const upload_attributes_files = async ({
  all_attributes,
  setIsLoading,
}) => {
  let all_updated_attributes = [];
  let upload_attributes_files = [];
  let upload_attributes_full_files = [];

  for (let i = 0; i < all_attributes.length; i++) {
    const element = all_attributes[i];

    // Set in state
    if (element.uploadFile) {
      upload_attributes_files.push({
        name: element.values[0].name,
        type: element.values[0].type,
        id: element.id,
      });
      upload_attributes_full_files.push(element.values[0]);
    } else {
      all_updated_attributes.push(element);
    }

    // Upload file checking
    if (all_attributes.length === i + 1 && upload_attributes_files.length > 0) {
      try {
        const response = await networkService.networkCall(
          APPURL.URLPaths.S3signedUploadURL,
          'POST',
          JSON.stringify({
            files: upload_attributes_files.map(file => {
              return {name: file.name, type: file.type};
            }),
          }),
        );

        const responseFiles = response.data.result;
        for (let index = 0; index < responseFiles.length; index++) {
          const path = responseFiles[index].signedUrl;
          const fileURI = responseFiles[index].fileUri;

          try {
            const res = await fetch(path, {
              method: 'PUT',
              headers: {
                ContentType: upload_attributes_files[index].type,
              },
              body: upload_attributes_full_files[index],
            });

            if (res.ok) {
              all_updated_attributes.push({
                values: [fileURI],
                id: upload_attributes_files[index].id,
              });
            }
          } catch (error) {
            ToastPopup({
              type: 'error',
              message: error?.data?.message ?? 'Something is wrong',
            });
            setIsLoading(false);
          }
        }
      } catch (error) {
        ToastPopup({
          type: 'error',
          message: error?.data?.message ?? 'Something is wrong',
        });
        setIsLoading(false);
      }
    }

    // return all images url
    if (all_updated_attributes.length == all_attributes.length) {
      return all_updated_attributes;
    }
  }
};
